var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrozenGoodsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.25l12.5-7.5m-8.054-2.5L7.25 4.125 9.054 2.25H5.446zm3.608 12.5L7.25 12.875 5.446 14.75h3.608zM7.25 1v15V1zM1.14 6.999l2.464-.686-.66-2.562L1.14 7zM13.36 10l-2.464.687.66 2.56 1.805-3.247zM1 4.75l12.5 7.5L1 4.75zm1.944 8.499l.66-2.562-2.464-.686 1.804 3.248zm8.612-9.498l-.66 2.562 2.464.686-1.804-3.248z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgFrozenGoodsIcon;